// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { showSubmitModal } from "../redux/reducers/view";
import { PlasmicSubmitExamModal } from "./plasmic/cps/PlasmicSubmitExamModal";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { assignmentSubmitRequest } from "../redux/reducers/assignmentRequest";
import { toggleExamComplete } from "../redux/reducers/userProgramsFull";

function SubmitExamModal_(props, ref) {
  // Use PlasmicSubmitExamModal to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicSubmitExamModal are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all SubmitExamModalProps here, but feel free
  // to do whatever works for you.
  return <div>
  {props.viewReducer.showSubmitModal ? <div style={{position:'fixed', top:0, width:'100%',height:'100%', zIndex:1000}}>
    <PlasmicSubmitExamModal root={{ ref }} {...props}
    btnYes={{
      onClick:(e)=>{
        props.assignmentSubmitRequest('blah')
        props.toggleExamComplete(true)
        props.showSubmitModal(false)

      }
    }}
    btnNo={{
      onClick:(e)=>{
        props.showSubmitModal(false)
      }
    }}
    btnClose={{
      onClick:(e)=>{
        props.showSubmitModal(false)
      }
    }}
  /></div>:null}
  </div>
}

const SubmitExamModal = React.forwardRef(SubmitExamModal_);


const mapStateToProps = state => ({
  login: state.loginReducer,
  viewReducer: state.viewReducer
});
const mapDispatchToProps = dispatch => ({
  showSubmitModal: value => dispatch(showSubmitModal(value)),
  assignmentSubmitRequest: obj => dispatch(assignmentSubmitRequest(obj)),
  toggleExamComplete: bool => dispatch(toggleExamComplete(bool)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SubmitExamModal);
